import * as yup from "yup";

const authSchema = yup.object().shape({
    email: yup.string().email("Escriba un email válido").required("Su email es requerido."),
    password: yup.string().required("Su contraseña es requerida."),
});

export {
    authSchema
}